class CustomSelectField extends HTMLElement {
  constructor() {
    super();

    this.placeHolder = this.querySelector('.custom-select-field__placeholder');
    this.label = this.querySelector('.custom-select-field__placeholder__label');
    this.options = this.querySelector('.custom-select-field__options');
    this.radios = this.querySelectorAll('input[type="radio"]');
    this.checkboxes = this.querySelectorAll('input[type="checkbox"]');

    this.placeHolder?.addEventListener('click', this.toggleOptions.bind(this));
    this.radios.forEach((radio) => {
      radio.addEventListener('change', () => {
        this.onSelect(radio);
      });
    });
    this.checkboxes.forEach((checkbox) => {
      checkbox.addEventListener('change', () => {
        this.onSelect(checkbox);
      });
    });
  }

  toggleOptions(e) {
    this.classList.toggle('open');
    this.options?.classList.toggle('show');
  }

  onSelect(elm) {
    this.label.textContent = this.querySelector(`label[for="${elm.id}"]`)?.textContent;
    this.querySelector('.custom-select-field__option.active')?.classList.remove('active');
    elm.closest('.custom-select-field__option').classList.add('active');
    this.close();
    this.clearError();
  }

  close() {
    this.classList.remove('open');
    this.options?.classList.remove('show');
  }

  isValid() {
    return !!this.querySelector('input[type="radio"]:checked');
  }

  showError() {
    if (this.closest('.full-field')) {
      this.closest('.full-field').classList.add('is-error');
      this.closest('.full-field')
        .querySelector('.field__error')
        ?.classList.remove('hidden');
    }

    if (this.closest('.half-field')) {
      this.closest('.half-field').classList.add('is-error');
      this.closest('.half-field')
        .querySelector('.field__error')
        ?.classList.remove('hidden');
    }
  }

  clearError() {
    if (this.closest('.full-field')) {
      this.closest('.full-field').classList.remove('is-error');
      this.closest('.full-field')
        .querySelector('.field__error')
        ?.classList.add('hidden');
    }

    if (this.closest('.half-field')) {
      this.closest('.half-field').classList.remove('is-error');
      this.closest('.half-field')
        .querySelector('.field__error')
        ?.classList.add('hidden');     
    }
  }
}

customElements.define('custom-select-field', CustomSelectField);